import React from 'react';
import { i18nClient } from '@sailor/i18n-mach-pro';
import SubmitButton from '../SubmitButton';
import { lxClickReport } from '@/src/pages/customer_service/lib/lx';
import { CustomerCid } from '@/src/pages/customer_service/contant';
import './index.css';
import { EnumLxPositionName, LX_EMPTY_VALUE } from '@/src/pages/customer_service/lib/constant';

export default function ChatButton(props: any) {
  const { onClick, bizline } = props || {};

  const getButtonName = () => i18nClient.getText('cs_portal_contact_customer_service', 'Customer service');

  const handleClick = () => {
    onClick?.();

    // 埋点信息上报
    lxClickReport(CustomerCid.HomePage, 'b_oversea_helpcenter_68ln2ke9_mc', {
      button_name: getButtonName(),
      event_name: '[machPro]联系客服点击',
      position_name: EnumLxPositionName.ForwardHuman,
      question_name: LX_EMPTY_VALUE,
      faq_id: LX_EMPTY_VALUE,
      recommendation_list: LX_EMPTY_VALUE,
      bizline
    });
  };

  return (
    <view className="submit-wrapper">
      <SubmitButton
        type="secondary"
        className="chat-button"
        fullWidth={false} // 当前不会有PC，可以为 false
        icon="icon_chat btn-icon"
        text={getButtonName()}
        onClick={handleClick}
      />
    </view>
  );
}
